export const navigationLinks = [
  { path: '/', label: 'Home' },
  { path: '/portfolio-details/1', label: 'Portfolio' },
  { path: '/contact', label: 'Contact' },
];
